import { gql } from '@apollo/client';

export const templateItemBase = gql`
  fragment templateItemBase on DocumentTemplateItem {
    documentTemplateId
    templateName
    exportType
    sharepointContentType
    needsSigning
    documentTypeId
    requiresAllDocs
    uspName
    outputType
    saveOnLocalDisk
    localDiskSavePath
    localDiskFileName
    sharepointUse
    filterCondition
    displayOrder
    mailMergeSP
    targetAreaId
    hasMetadata
    templateCode
    uniqueByDocument
    bulkPrintingYN
    requiredDocTypeId
  }
`;

export const templateItemExtended = gql`
  fragment templateItemExtended on DocumentTemplateItem {
    documentTemplateFilters {
      filterId
      templateId
      paramId
      operatorId
      orderNo
      filterValue
      filterValueId
      paramName
      operatorName
      paramIsList
      operatorIsMultipleSelection
      filterValues {
        valueId
        filterId
        filterValue
        filterValueId
      }
    }
    documentTemplateXUserGroups {
      documentTemplateId
      userGroupId
    }
    documentTemplateXSignatures {
      documentTemplateId
      signatureId
      implicit
    }
    documentTemplateXOptionBookmarks {
      id
      bookmarkName
      dataSource
      templateId
    }
    signatureBookmarks {
      id
      name
      templateId
      isTable
      signatureBookmarkActors {
        id
        signatureBookmarkId
        actorId
      }
    }
  }
`;
